import { render, staticRenderFns } from "./ReportStats.vue?vue&type=template&id=407f4656&"
import script from "./ReportStats.vue?vue&type=script&lang=js&"
export * from "./ReportStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407f4656')) {
      api.createRecord('407f4656', component.options)
    } else {
      api.reload('407f4656', component.options)
    }
    module.hot.accept("./ReportStats.vue?vue&type=template&id=407f4656&", function () {
      api.rerender('407f4656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportStats.vue"
export default component.exports